import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { changeOrder } from '../../../redux/reducers/skills';
// components
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import SkillBlock from './SkillBlock';

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'rgba(86, 204, 242, 0.05)' : ''
});

const getItemStyle = draggableStyle => ({
  userSelect: 'none',
  ...draggableStyle
});

class SkillsListEdit extends Component {
  onDragEnd = e => {
    const { changeOrder, userSkills } = this.props;
    const { source, destination } = e;

    if (
      source === null ||
      destination === null ||
      source.index === destination.index
    ) {
      return null;
    }

    const newSkills = [...userSkills];
    const movableSkill = newSkills.splice(source.index, 1)[0];
    newSkills.splice(destination.index, 0, movableSkill);
    const newSkillOrderIds = newSkills.map(({ id }) => id);
    changeOrder({ skill_id_list: newSkillOrderIds });
  };

  render() {
    const { userSkills } = this.props;
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppableSkills">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {userSkills.map((skill, index) => (
                <Draggable key={index} draggableId={skill.id} index={index}>
                  {(provided, snapshot) => (
                    <div>
                      <div
                        ref={provided.innerRef}
                        style={getItemStyle(
                          provided.draggableProps.style,
                          snapshot.isDragging
                        )}
                        {...provided.dragHandleProps}
                      >
                        <SkillBlock skill={skill} isEditMode />
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

SkillsListEdit.propTypes = {
  skills: T.arrayOf(
    T.shape({
      id: T.oneOfType([T.string, T.number]),
      title: T.string
    })
  )
};

export default connect(
  state => ({
    userSkills: state.skills.userSkills
  }),
  { changeOrder }
)(SkillsListEdit);



// WEBPACK FOOTER //
// ./src/containers/Skills/components/SkillsListEdit.jsx